
import { ApplicationUserModel, StationModel } from '@/libs/Api';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import Page from '@/Page.vue';
import { Component, Ref } from 'vue-property-decorator';
import { applicationUserStore } from '@/libs/user-settings/+state/store';
import { Guid } from '@/libs/common/functions/guid';
import { stationsStore } from '@/libs/stations/+state/store';
import StationDefectsList from './StationDefectsList.vue';
import StationMachineComponentsList from './StationMachineComponentsList.vue';

@Component({
    components: { StationDefectsList, StationMachineComponentsList },
})
export default class StationDialog extends Page {
    id!: string;
    dialog = false;
    valid = true;
    saving = false;
    loading = false;
    applicationUser: ApplicationUserModel = applicationUserStore.useGetter(CrudGetter.Detail) as ApplicationUserModel;
    station: StationModel | null = null;
    deleteDialog = false;
    deleting = false;

    @Ref() form!: any;

    get isNewItem(): boolean {
        return this.station?.id == Guid.EmptyGuid();
    }

    open(id: string) {
        this.dialog = true;
        this.id = id;
        this.load();
    }

    close() {
        this.dialog = false;
    }

    deleteClick() {
        this.deleteDialog = true;
    }

    deleteStation() {
        this.deleting = true;
        stationsStore.dispatch(CrudAction.Delete, { id: this.id });
        this.subscribe(stationsStore, CrudReponse.Delete)
            .then((e: any) => {
                this.deleting = false;
                this.deleteDialog = false;
                this.close();
            })
            .catch((e: any) => {
                this.deleting = false;
            });
    }

    private load(): Promise<any> {
        if (this.id != Guid.EmptyGuid()) {
            this.loading = true;
            return new Promise((resolve, reject) => {
                this.loadStation()
                    .then((e) => {
                        this.loading = false;
                        resolve(e);
                    })
                    .catch((e: any) => {
                        reject(e);
                    });
            });
        } else {
            this.station = {
                id: Guid.EmptyGuid(),
                code: '',
                name: '',
            } as StationModel;
            return new Promise((resolve, reject) => {
                resolve(null);
            });
        }
    }

    private loadStation() {
        return new Promise((resolve, reject) => {
            stationsStore.dispatch(CrudAction.Get, { id: this.id });
            this.subscribe(stationsStore, CrudReponse.Get)
                .then((e) => {
                    this.station = e;
                    resolve(e);
                })
                .catch((e: any) => {
                    reject(e);
                });
        });
    }

    private save() {
        if (this.form.validate()) {
            const station = { ...this.station };
            this.saving = true;
            if (this.id == Guid.EmptyGuid()) {
                stationsStore.dispatch(CrudAction.Create, { item: station });
                this.subscribe(stationsStore, CrudReponse.Create)
                    .then(() => {
                        this.load().then(() => {
                            this.saving = false;
                            this.close();
                        });
                    })
                    .catch((e) => {
                        this.saving = false;
                        throw e;
                    });
            } else {
                stationsStore.dispatch(CrudAction.Update, { item: station });
                this.subscribe(stationsStore, CrudReponse.Update)
                    .then(() => {
                        this.load().then(() => {
                            this.saving = false;
                            this.close();
                        });
                    })
                    .catch((e) => {
                        this.saving = false;
                        throw e;
                    });
            }
        }
    }
}
